import { render, staticRenderFns } from "./CreateAccountPopup.vue?vue&type=template&id=2091467f"
import script from "./CreateAccountPopup.vue?vue&type=script&lang=js"
export * from "./CreateAccountPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports